let currentDataSet = "";

export const updateDataSet = (dataSet: string) => {
  currentDataSet = dataSet;
};

export const dataSetHeader = () => ({ ["X-Entrilia-BI-DataSet"]: currentDataSet });
